import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'

import { theme } from '@emico/styles'

interface SeparatorWrapperProps {
  variant: 'default' | 'small' | 'large'
}
const SeparatorWrapper = styled.div<SeparatorWrapperProps>`
  height: 1px;
  background-color: ${theme.subtleColor};

  ${(props) =>
    props.variant === 'default' &&
    css`
      margin: 0;
    `}

  ${(props) =>
    props.variant === 'small' &&
    css`
      margin: 10px 0 15px;
    `}

  ${(props) =>
    props.variant === 'large' &&
    css`
      margin: 20px 0 25px;
    `}
`

interface OwnProps {
  variant?: 'default' | 'small' | 'large'
}

type Props = OwnProps & React.HTMLAttributes<HTMLDivElement>

const Separator = ({ variant = 'default', className, ...other }: Props) => (
  <SeparatorWrapper variant={variant} className={className} {...other} />
)

export default Separator
